import React, { Component } from 'react';
import { connect } from "react-redux";
import './Main.css';
import { Container, Row, Col, Button, ButtonGroup, ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import MapBrowser from './map';
import Summary from '../summary/Summary';
import Summary2 from '../summary/Summary2';
import SummaryRowing from '../summary/SummaryRowing';
import SummaryAutoRace from '../summary/SummaryAutoRace';
import Table from 'react-bootstrap/Table';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip, ReferenceDot, ScatterChart, Scatter, ReferenceLine } from 'recharts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Practices from '../../models/Practices';
import Loading from '../Loading';
import { main, teamList, playerSelector } from "../../actions";
import { Tab, Tabs } from 'react-bootstrap';
import Polar from './polar/polar';
import Motion from './motion/Motion';
import PropTypes from 'prop-types';
import TeamList from '../sidePanel/Team/TeamList';
import Slider from "../slider/Slider";
import { to_d, copyToClipboard, downloadCSV } from '../helpers';
import Leg from '../../models/Leg';
import Practice from '../../models/Practice';
import moment from 'moment-timezone';
import { isSailingLike, isAutoRace, DISP_MODE } from '../../dispMode';


const dispItems = [
  { "id": 0, "name": "SOG", "value": 0, "dataKeyStb": "spd_s", "dataKeyPt": "spd_p", "unit": "km/h" },
  { "id": 1, "name": "VMG", "value": 0, "dataKeyStb": "vmg_s", "dataKeyPt": "vmg_p", "unit": "km/h" },
  { "id": 2, "name": "TWA", "value": 0, "dataKeyStb": "ang_s", "dataKeyPt": "ang_p", "unit": "deg" },
  { "id": 3, "name": "Heading", "value": 0, "dataKeyStb": "hed_s", "dataKeyPt": "hed_p", "unit": "deg" },
  { "id": 4, "name": "TWS", "value": 0, "dataKeyStb": "wds_s", "dataKeyPt": "wds_p", "unit": "m/s" },
  { "id": 5, "name": "TWD", "value": 0, "dataKeyStb": "wdd_s", "dataKeyPt": "wdd_p", "unit": "deg" },
  { "id": 6, "name": "Pitch", "value": 0, "dataKeyStb": "pit_s", "dataKeyPt": "pit_p", "unit": "deg" },
  { "id": 7, "name": "Heel", "value": 0, "dataKeyStb": "rol_s", "dataKeyPt": "rol_p", "unit": "deg" },
  { "id": 8, "name": "DTM", "value": 0, "dataKeyStb": "dis_s", "dataKeyPt": "dis_p", "unit": "m" },
  { "id": 9, "name": "VMC", "value": 0, "dataKeyStb": "vel_s", "dataKeyPt": "vel_p", "unit": "m/s" },
  { "id": 10, "name": "DistUp", "value": 0, "dataKeyStb": "mupd_s", "dataKeyPt": "mupd_p", "unit": "m" },
  { "id": 11, "name": "Log", "value": 0, "dataKeyStb": "dist_s", "dataKeyPt": "dist_p", "unit": "m" },
  { "id": 12, "name": "Drift", "value": 0, "dataKeyStb": "drf_s", "dataKeyPt": "drf_p", "unit": "deg" },
  { "id": 13, "name": "Dist2Member", "value": 0, "dataKeyStb": "dtm_s", "dataKeyPt": "dtm_p", "unit": "m" },
  { "id": 14, "name": "ax", "value": 0, "dataKeyStb": "ax_s", "dataKeyPt": "ax_p", "unit": "G" },
  { "id": 15, "name": "ay", "value": 0, "dataKeyStb": "ay_s", "dataKeyPt": "ay_p", "unit": "G" },
  { "id": 16, "name": "gz", "value": 0, "dataKeyStb": "gz_s", "dataKeyPt": "gz_p", "unit": "deg/s" },
  { "id": 17, "name": "Az", "value": 0, "dataKeyStb": "az_s", "dataKeyPt": "az_p", "unit": "G" },
  { "id": 18, "name": "gx", "value": 0, "dataKeyStb": "gx_s", "dataKeyPt": "gx_p", "unit": "deg/s" },
  { "id": 19, "name": "gy", "value": 0, "dataKeyStb": "gy_s", "dataKeyPt": "gy_p", "unit": "deg/s" },
];

const memberItems = [
  { "id": 0, "name": "SOG", "value": 0, "dataKey": "m_spd", "dataKeyStb": "m_spd_s", "dataKeyPt": "m_spd_p", "unit": "km/h" },
  { "id": 1, "name": "VMG", "value": 0, "dataKey": "m_vmg", "dataKeyStb": "m_vmg_s", "dataKeyPt": "m_vmg_p", "unit": "km/h" },
  { "id": 2, "name": "TWA", "value": 0, "dataKey": "m_ang", "dataKeyStb": "m_ang_s", "dataKeyPt": "m_ang_p", "unit": "deg" },
  { "id": 3, "name": "Heading", "value": 0, "dataKey": "m_hed", "dataKeyStb": "m_hed_s", "dataKeyPt": "m_hed_p", "unit": "deg" },
  { "id": 4, "name": "TWS", "value": 0, "dataKey": "m_wds", "dataKeyStb": "m_wds_s", "dataKeyPt": "m_wds_p", "unit": "m/s" },
  { "id": 5, "name": "TWD", "value": 0, "dataKey": "m_wdd", "dataKeyStb": "m_wdd_s", "dataKeyPt": "m_wdd_p", "unit": "deg" },
  { "id": 6, "name": "Pitch", "value": 0, "dataKey": "m_pit", "dataKeyStb": "m_pit_s", "dataKeyPt": "m_pit_p", "unit": "deg" },
  { "id": 7, "name": "Heel", "value": 0, "dataKey": "m_rol", "dataKeyStb": "m_rol_s", "dataKeyPt": "m_rol_p", "unit": "deg" },
  { "id": 8, "name": "DTM", "value": 0, "dataKey": "m_dis", "dataKeyStb": "m_dis_s", "dataKeyPt": "m_dis_p", "unit": "m" },
  { "id": 9, "name": "VMC", "value": 0, "dataKey": "m_vel", "dataKeyStb": "m_vel_s", "dataKeyPt": "m_vel_p", "unit": "m/s" },
  { "id": 10, "name": "DistUp", "value": 0, "dataKey": "m_mupd", "dataKeyStb": "m_mupd_s", "dataKeyPt": "m_mupd_p", "unit": "m" },
  { "id": 11, "name": "Log", "value": 0, "dataKey": "m_dist", "dataKeyStb": "m_dist_s", "dataKeyPt": "m_dist_p", "unit": "m" },
  { "id": 12, "name": "Drift", "value": 0, "dataKey": "m_drf", "dataKeyStb": "m_drf_s", "dataKeyPt": "m_drf_p", "unit": "deg" },
  { "id": 13, "name": "Dist2Member", "value": 0, "dataKey": "m_dtm", "dataKeyStb": "m_dtm_s", "dataKeyPt": "m_dtm_p", "unit": "m" },
  { "id": 14, "name": "ax", "value": 0, "dataKey": "m_ax", "dataKeyStb": "m_ax_s", "dataKeyPt": "m_ax_p", "unit": "G" },
  { "id": 15, "name": "ay", "value": 0, "dataKey": "m_ay", "dataKeyStb": "m_ay_s", "dataKeyPt": "m_ay_p", "unit": "G" },
  { "id": 16, "name": "gz", "value": 0, "dataKey": "m_gz", "dataKeyStb": "m_gz_s", "dataKeyPt": "m_gz_p", "unit": "deg/s" },
  { "id": 17, "name": "Az", "value": 0, "dataKey": "m_az", "dataKeyStb": "m_az_s", "dataKeyPt": "m_az_p", "unit": "G" },
  { "id": 18, "name": "gx", "value": 0, "dataKey": "m_gx", "dataKeyStb": "m_gx_s", "dataKeyPt": "m_gx_p", "unit": "deg/s" },
  { "id": 19, "name": "gy", "value": 0, "dataKey": "m_gy", "dataKeyStb": "m_gy_s", "dataKeyPt": "m_gy_p", "unit": "deg/s" },
];

const dataLog = [
];


//現在のプラクティスorレグIDを保持、変更があった場合、必要な初期化処理をDidupdateにて実施
var prevPracticeId = null;
var prevLegId = null;
var upd_time = null;
var prevPractices = null;
var prevUserId = null;

//現在表示中のTabを保持
var activeTab = null;

//Map表示用デバイスクラス的な
function Device(id, spd, vmg, ang, pos, rotate, lines, main, wind, wds, wdd, all_lines, name, unit, wind_unit,
  high10sSpdSegments, // g.spd >= max_10s_spd
  high10s95perSpdSegments, // g.spd >= max_10s_spd*0.95
  aveSpdSegments,     // g.spd >= ave_speed
  maxSpdSegments,      // g.spd >= max_speed
  coloredLines, // Added: Array of {pos, isStb}
  maxSpeedPoint, // Added: {pos, speed, ...}
  sessionMaxSpeed // Added: Practice Max Speed
) {
  this.id = id;
  this.spd = spd;
  this.vmg = vmg;
  this.ang = ang;
  this.pos = pos;
  this.rotate = rotate;
  this.all_lines = all_lines;
  this.lines = lines;
  this.main = main;
  this.wind = wind;
  this.windspd = wds;
  this.winddir = wdd;
  this.isStarboard = true;
  this.name = name;
  this.unit = unit;
  this.wind_unit = wind_unit;
  this.high10sSpdSegments = high10sSpdSegments;
  this.high10s95perSpdSegments = high10s95perSpdSegments;
  this.aveSpdSegments = aveSpdSegments;
  this.maxSpdSegments = maxSpdSegments;
  this.coloredLines = coloredLines;
  this.maxSpeedPoint = maxSpeedPoint;
  this.sessionMaxSpeed = sessionMaxSpeed;
}


class Track extends React.Component {

  static propTypes = {
    handleSelectTargetPracticesOrLeg: PropTypes.func,
  }

  //Variable
  ws = null;
  firstGps = true;

  //Constractor
  constructor(props) {
    super(props);
    this.state = {
      list: dispItems,
      device: "7777",
      graph: dataLog,
      limit: 600,
      isToggleOn: false,
      dataKeyId: 0,
      dataKeyStb: "spd_s",
      dataKeyPt: "spd_p",
      dataKeyMember: "m_spd",
      center: { lat: 35.301318, lng: 139.480219 },
      windspeed: 0,
      winddir: 0,
      windpos: { lat: 0, lng: 0 },
      deviceMap: {
        7777:
        {
          id: '7777',
          spd: 0,
          vmg: 0,
          ang: 0,
          pos: [0, 0],
          rotate: 0,
          lines: [],
          unit: "km/h",
          wind_unit: "m/s",
        }
      },
      isStarboard: true,
      isAuto: true,
      loading: false,
      now_t: "00:00:00",
      end_t: "00:00:00",
      select_from_t: "00:00:00.0",
      select_to_t: "00:00:00.0",
      yaxis: false,
      selectedSpd: 0,
      selectedDir: 0,
      colorMode: (() => {
        const event = props.authUser && props.authUser.organization && props.authUser.organization.event;
        // wind foilは擬似カラー(Speed)表示をデフォルトにする
        if (event && event.disp_mode === DISP_MODE.WIND_FOIL) return 'speed';
        return isSailingLike(event) ? 'sailing' : 'speed';
      })(),
      memberPolar: null,
      test: 0,
      graphHeight: 10,
      polarSize: 250,
      zoom: 15,
      isPC: true,
      gridIndex: 0,
      calcLine: [],
      selectionRange: { min: 0, max: this.props.gpsLog ? this.props.gpsLog.length - 1 : 0 },
      dataRange: { min: 0, max: this.props.gpsLog ? this.props.gpsLog.length - 1 : 0, step: 1 },
      showAllIMU: false,
    };


    this.handleMouseMoveOnGraph = this.handleMouseMoveOnGraph.bind(this);
    this.handleSelectTabs = this.handleSelectTabs.bind(this);
    this.windowSizecheck = this.windowSizecheck.bind(this);
    this.handleSelectTargetPracticesOrLeg = this.handleSelectTargetPracticesOrLeg.bind(this);
    this.setSlider = this.setSlider.bind(this)
    this.handleSelectDataRange = this.handleSelectDataRange.bind(this)
    this.handleClickSelectTime = this.handleClickSelectTime.bind(this)
    this.toggleIMU = this.toggleIMU.bind(this);
    this.handleClickCopyUpData = this.handleClickCopyUpData.bind(this)
    this.handleClickCopyDwData = this.handleClickCopyDwData.bind(this)
    this.handleClickCopyMotionData = this.handleClickCopyMotionData.bind(this)

  }

  // Generate Gradient Stops for Graph based on LegMax / SessionMax ratio
  renderGradientStops() {
    const dev = this.state.deviceMap[this.props.target.user.id];
    if (!dev) return null;

    const sessionMax = dev.sessionMaxSpeed || ((dev.maxSpeedPoint && dev.maxSpeedPoint.speed) ? dev.maxSpeedPoint.speed : 10);
    const legMax = (dev.maxSpeedPoint && dev.maxSpeedPoint.speed) ? dev.maxSpeedPoint.speed : sessionMax;

    // Scale Stops (0% -> 90% of SessionMax)
    // 0% (Blue), 22.5% (Cyan), 45% (Lime), 67.5% (Yellow), 90% (Red)
    const steps = [
      { pct: 0, color: 'blue' },
      { pct: 0.225, color: 'cyan' },
      { pct: 0.45, color: 'lime' },
      { pct: 0.675, color: 'yellow' },
      { pct: 0.9, color: 'red' },
      { pct: 1.0, color: 'red' } // Cap
    ];

    return steps.map((step, index) => {
      // Calculate offset in Graph (% of Bounding Box Height = LegMax)
      // Step.pct * SessionMax = Speed value
      // Speed / LegMax = Gradient Offset
      const offsetVal = (step.pct * sessionMax) / legMax;
      const offset = `${offsetVal * 100}%`;
      return <stop key={index} offset={offset} stopColor={step.color} />;
    });
  }

  componentDidMount() {
    let newDevMap = this.state.deviceMap;
    delete newDevMap[7777];//delete

    this.windowSizecheck();
    window.addEventListener('resize', this.windowSizecheck);
  }

  windowSizecheck() {
    var graphSize = 0;
    var polarSize = 0;
    var zoom = 0;
    var isPC = true;
    // @media screen and (max-width: 780px) と同じ
    var mql = window.matchMedia('screen and (max-width: 992px)');

    function checkBreakPoint(mql) {
      if (mql.matches) {//Mobile
        graphSize = 170;
        polarSize = 190;
        zoom = 14;
        isPC = false;
      } else {//PC
        graphSize = 250;
        polarSize = 250;
        zoom = 15;
        isPC = true;
      }
    }
    // ブレイクポイントの瞬間に発火
    mql.addListener(checkBreakPoint);

    // 初回チェック
    checkBreakPoint(mql);

    this.setState({
      graphHeight: graphSize,
      polarSize: polarSize,
      zoom: zoom,
      isPC: isPC,
    });

  }



  //グラフ上のマウスオーバーを検知
  handleMouseMoveOnGraph(event) {

    let index = event.activeTooltipIndex;

    if (index == undefined) {
      return;
    } else {
      //Trackingモードタブのみ、リストを更新する
      this.updateListData(index);
      this.updateMapData(index);
    }

    //データ選択区間の自動化
    let r = this.state.selectionRange;
    let new_max = r.max;
    if (index > r.max) {
      new_max = this.props.gpsLog.length - 1;
    }

    let selectedPoint = { firstPoint: index, secondPoint: new_max };
    let selectedStartTime = this.props.gpsLog[selectedPoint.firstPoint].time
    let selectedEndTime = this.props.gpsLog[selectedPoint.secondPoint].time

    this.setState(state => ({
      select_from_t: selectedStartTime,
      select_to_t: selectedEndTime,
      selectionRange: {
        min: index,
        max: new_max,
      }
    }));
  }


  //Tabsのイベント
  handleSelectTabs(eventKey) {
    this.activeTab = eventKey;
  }

  //練習日送り・戻しボタンのイベント
  handleClickLeg(currentTarget, handleSelectTargetLeg, direction) {
    //Main.jsのtargetのPractices内のインデックスを取得
    var legIndex = currentTarget.practice.legs._legs.findIndex((p) => p.id === currentTarget.id);
    legIndex = legIndex + direction;
    let newTarget = currentTarget.practice.legs._legs[legIndex];
    handleSelectTargetLeg(newTarget);
  }

  //グラフ表示データの切り替え
  changeGraph(id) {
    let disp = this.state.list;

    this.setState(state => ({
      dataKeyId: id,
      dataKeyStb: disp[id].dataKeyStb,
      dataKeyPt: disp[id].dataKeyPt,
      dataKeyMember: memberItems[id].dataKey,
    }));

    //グラフデータの再作成
    let ary = this.props.gpsLog;
    if (id <= 3) {
      if (id == 2) {
        this.setState({
          yaxis: true,
        });
      } else {
        this.setState({
          yaxis: false,
        });
      }
    } else if (id <= 5) {
      ary = this.props.windLog;
      this.setState({
        yaxis: false,
      });
    } else if (id <= 7) {
      ary = this.props.motionLog;
      this.setState({
        yaxis: false,
      });
    } else if (id <= 9) {
      ary = this.props.buoyLog;
      this.setState({
        yaxis: false,
      });
    } else if (id <= 10) {
      ary = this.props.max_up_distance;
      this.setState({
        yaxis: false,
      });
    } else if (id <= 19) {
      ary = this.props.gpsLog;
      this.setState({
        yaxis: false,
      });
    }

    if (ary != undefined) {
      //Refresh!
      this.setState({
        graph: ary.slice(),
      });
    }
    this.setState({
      gridIndex: id,
    });
  }
  toggleIMU() {
    this.setState({ showAllIMU: !this.state.showAllIMU });
  }
  calculateDistToMember() {
    const p = this.props;
    if (!p.gpsLog || p.gpsLog.length === 0) return;

    const memberPractice = p.practices ? p.practices.find((m) => m.user.id !== p.target.user.id) : null;
    if (!memberPractice) return;
    
    const getDistance = (lat1, lon1, lat2, lon2) => {
      const R = 6378137;
      const dLat = (lat2 - lat1) * Math.PI / 180;
      const dLon = (lon2 - lon1) * Math.PI / 180;
      const a = 
        Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
        Math.sin(dLon/2) * Math.sin(dLon/2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      return R * c;
    };

    const targetGpses = p.target.legs && p.target.legs.gpses ? p.target.legs.gpses : (p.target.gpses ? p.target.gpses : []);
    const memberGpses = memberPractice.legs && memberPractice.legs.gpses ? memberPractice.legs.gpses : (memberPractice.gpses ? memberPractice.gpses : []);

    p.gpsLog.forEach((g, idx) => {
      let dist = 0;
      const gTimeStr = (typeof g.time === 'string') ? g.time : (g.time && typeof g.time.format === 'function' ? g.time.format("HH:mm:ss.SS") : null);

      if (memberPractice && memberPractice.gpsLog && gTimeStr) {
        const mIdx = memberPractice.gpsLog.findIndex((item) => {
          const itemTimeStr = (typeof item.time === 'string') ? item.time : (item.time && typeof item.time.format === 'function' ? item.time.format("HH:mm:ss.SS") : null);
          return itemTimeStr === gTimeStr;
        });

        if (mIdx !== -1) {
          const selfGps = targetGpses[idx];
          const memberGps = memberGpses[mIdx];
          
          if (selfGps && memberGps) {
            dist = getDistance(selfGps.lat, selfGps.lon, memberGps.lat, memberGps.lon);
          }
        }
      }
      
      const targetGps = targetGpses[idx];
      if (targetGps) {
        targetGps.distToMember = Math.round(dist * 10) / 10;
      }

      const isStb = g.spd_p === null;
      g.distToMember = Math.round(dist * 10) / 10;
      if (isStb) {
        g.dtm_s = Math.round(dist * 10) / 10;
        g.dtm_p = null;
      } else {
        g.dtm_s = null;
        g.dtm_p = Math.round(dist * 10) / 10;
      }
    });
  }

  initListData() {
    this.calculateDistToMember();
    this.updateListData(0);

    //スライドバー時間の初期化
    this.setState({
      select_from_t: this.props.gpsLog ? this.props.gpsLog[0].time : "00:00:00.0",
      select_to_t: this.props.gpsLog ? this.props.gpsLog[this.props.gpsLog.length - 1].time : "00:00:00.0",
      dataRange: { min: 0, max: this.props.gpsLog ? this.props.gpsLog.length - 1 : 0, step: 1 },
      selectionRange: { min: 0, max: this.props.gpsLog ? this.props.gpsLog.length - 1 : 0 },
      calcLine: [],
    });

  }


  //性能対策（表示点数の抑制）
  reduceData(ary) {
    let size = 60 * 60;
    let disp_ary = [];
    if (ary.length > size) {
      let d = parseInt(ary.length / size);
      for (let i = 0; i < ary.length; i += d) {
        disp_ary.push(ary[i]);
      }
    }
    else
      disp_ary = ary;
    return disp_ary;
  }


  //初期表示時のデータ表示
  updateListData(i) {
    let graph = this.state.list;
    //Wind
    let g = this.props.gpsLog[i];
    let w = this.props.windLog[i];
    let m = this.props.motionLog[i];
    let d = this.props.buoyLog[i];
    let u = this.props.max_up_distance[i];

    let spd, vmg, ang, hed, pit, rol, dis, vel, wspd = 0, wdir = 0, upd, dist, drift, distToMember, ax, ay, gz, az, gx, gy;
    spd = g.spd;
    vmg = g.vmg;
    ang = g.ang;
    hed = g.hed;
    wspd = w.wds;
    wdir = w.wdd;
    pit = m.pit;
    rol = m.rol;
    dis = d.dis;
    vel = d.vel;
    upd = u.mupd;
    dist = g.dist;
    drift = g.drift;
    distToMember = g.distToMember !== undefined ? g.distToMember : 0;
    ax = g.ax !== undefined ? g.ax : 0;
    ay = g.ay !== undefined ? g.ay : 0;
    gz = g.gz !== undefined ? g.gz : 0;
    az = g.az !== undefined ? g.az : 0;
    gx = g.gx !== undefined ? g.gx : 0;
    gy = g.gy !== undefined ? g.gy : 0;
    graph[0].value = spd;
    graph[1].value = vmg;
    graph[2].value = ang;
    graph[3].value = hed;
    graph[4].value = wspd;
    graph[5].value = wdir;
    graph[6].value = pit;
    graph[7].value = rol;
    graph[8].value = dis;
    graph[9].value = vel;
    graph[10].value = upd;
    graph[11].value = dist;
    graph[12].value = drift;
    graph[13].value = distToMember;
    graph[14].value = Math.round(ax * 100) / 100;
    graph[15].value = Math.round(ay * 100) / 100;
    graph[16].value = Math.round(gz * 100) / 100;
    graph[17].value = Math.round(az * 100) / 100;
    graph[18].value = Math.round(gx * 100) / 100;
    graph[19].value = Math.round(gy * 100) / 100;
    //stateの更新
    this.setState({
      list: graph.slice(),
      windspeed: wspd,
      winddir: wdir,
      now_t: g.time,
      end_t: this.props.gpsLog[this.props.gpsLog.length - 1].time,
    });
  }


  //MemberのGPS航跡
  initMemberDeviceMap() {
    var p = this.props;
    var practices;

    if (p.practices) {
      practices = p.practices;
      ///前回のPracticesを記憶
      prevPractices = p.practices;
    } else if (prevPractices) {
      practices = prevPractices;
    } else
      return;

    //check unload practice form json
    var i = 0;
    for (i = 0; i < practices.length; i++) {
      if (practices[i].gpses[0] == undefined) {
        return;
      }
    }

    var st = this.props.target.started_at;
    var et = this.props.target.ended_at;

    var all_st = this.props.target.started_at;
    var all_et = this.props.target.ended_at;

    if (!this.props.target.practice) {
    }
    else {// or Leg
      all_st = this.props.target.practice.started_at;
      all_et = this.props.target.practice.ended_at;
    }

    var line = [];
    var all_line = [];
    var dev;
    //deviceMapの更新
    let newDevMap = this.state.deviceMap;
    practices.forEach(function (m) {
      m.gpses.forEach((mg) => {
        if ((all_st <= mg.time) && (mg.time <= all_et)) {
          all_line.push([mg.lat, mg.lon]);
        }
        if ((st <= mg.time) && (mg.time <= et)) {
          line.push([mg.lat, mg.lon]);
        }
      });

      //デバイスクラスの作成(GPSの１個目をマーカー位置)
      dev = new Device(m.user.id, 0, 0, 0,
        { lat: null, lng: null }, 0, line,
        false, false,
        0, 0, all_line, m.user.last_name);
      newDevMap[m.user.id] = dev;//update
    });

    //stateの更新
    this.setState({
      deviceMap: newDevMap,
    });
  }


  //Mapの初期表示状態の制御
  initDeviceMap() {
    this.updateMapData(0);
  }

  updateMapDataUsingTime(time) {
    this.updateMapData(0);
  }

  // Helper to calculate metadata for the track
  getTrackMetadata(gpsLog, windLog) {
    if (!gpsLog || !windLog) return { coloredLines: [], maxSpeedPoint: null };

    // Cache check
    if (this.cachedTrackMetadata && this.cachedTrackMetadata.gpsLogLength === gpsLog.length && this.cachedTrackMetadata.targetId === this.props.target.id) {
      return this.cachedTrackMetadata.data;
    }

    let coloredLines = [];
    let maxSpeed = -1;
    let maxSpeedPoint = null;

    for (let i = 0; i < gpsLog.length; i++) {
      const g = gpsLog[i];
      const w = windLog[i] || { wds: 0, wdd: 0 };
      const speed = parseFloat(g.spd);

      // Max Speed Logic
      if (speed > maxSpeed) {
        maxSpeed = speed;
        maxSpeedPoint = {
          speed: speed,
          pos: [g.lat || (this.props.target.gpsLine && this.props.target.gpsLine[i] ? this.props.target.gpsLine[i][0] : 0),
          g.lon || (this.props.target.gpsLine && this.props.target.gpsLine[i] ? this.props.target.gpsLine[i][1] : 0)],
          time: g.time,
          index: i // Added index for graph reference
        };
      }

      // Starboard/Port Logic
      let offset = w.wdd - g.hed;//  Wind - Head
      if (offset < 0) offset += 360;
      let isStb = (offset < 180);

      // Use lat/lon from gpsLog if available, else gpsLine
      let lat = g.lat;
      let lon = g.lon;
      if (!lat && this.props.target.gpsLine && this.props.target.gpsLine[i]) {
        lat = this.props.target.gpsLine[i][0];
        lon = this.props.target.gpsLine[i][1];
      }

      coloredLines.push({
        pos: [lat, lon],
        isStb: isStb,
        speed: speed // Added speed for Pseudo Color Mode
      });
    }

    const result = {
      coloredLines,
      maxSpeedPoint,
      sessionMaxSpeed: (this.props.target.sessionMaxSpeed || (this.props.target.practice ? this.props.target.practice.sessionMaxSpeed : maxSpeed))
    };
    this.cachedTrackMetadata = {
      gpsLogLength: gpsLog.length,
      targetId: this.props.target ? this.props.target.id : null,
      data: result
    };

    return result;
  }


  updateMapData(i) {
    var p = this.props;
    var s = this.state;

    var g = this.props.gpsLog[i];
    var m = this.props.motionLog[i];
    var w = this.props.windLog[i];
    var dev;
    var mp = null;

    // Calculate Metadata
    const { coloredLines, maxSpeedPoint, sessionMaxSpeed } = this.getTrackMetadata(this.props.gpsLog, this.props.windLog);

    //デバイスクラスの作成(GPSの１個目をマーカー位置)

    var dev = new Device(
      p.target.user.id,
      g.spd, g.vmg, g.ang,
      { lat: p.target.gpsLine[i][0], lng: p.target.gpsLine[i][1] },
      g.hed,
      p.target.gpsLine,
      true, false,
      w.wds, w.wdd,
      p.target.gpsAllLine,
      p.target.user.last_name,
      p.target.user.unit,
      p.target.user.wind_unit,
      // ★ 追加分：条件付き配列（2次元）
      p.target.high10sSpdSegments,
      p.target.high10s95perSpdSegments,
      p.target.aveSpdSegments,
      p.target.maxSpdSegments,
      coloredLines,
      maxSpeedPoint,
      sessionMaxSpeed
    );

    //deviceMapの更新
    let newDevMap = this.state.deviceMap;
    newDevMap[p.target.user.id] = dev;//update

    //MemberのPracticesがあるかどうか
    if (p.practices) {
      p.practices.forEach(function (m) {
        if (s.deviceMap[m.user.id]) {

          //memberのpolarで配列を作る
          if (m.polar)
            mp = m.polar;

          m.gpsLog.forEach((mg, index) => {
            if (mg.time == g.time) {
              let gg = m.gpsLog[index];
              let mm = m.motionLog[index];
              let ww = m.windLog[index];
              var dd = new Device(
                m.user.id,
                gg.spd,
                gg.vmg,
                gg.ang,
                { lat: m.gpsLine[index][0], lng: m.gpsLine[index][1] },
                gg.hed,
                s.deviceMap[m.user.id].lines,
                false, false,
                ww.wds, ww.wdd, s.deviceMap[m.user.id].all_lines, m.user.last_name, m.user.unit, m.user.wind_unit,
                // ★ 追加分：条件付き配列（2次元）
                [[]],
                [[]],
                [[]],
                [[]],
                [], // coloredLines
                null, // maxSpeedPoint
                m.sessionMaxSpeed // sessionMaxSpeed
              );

              newDevMap[m.user.id] = dd;//update
              return;
            }
          });
        } else {
          if (mp)
            mp = null;
        }
      });
    }

    //Polarに渡す風上に対する角度を計算
    let polar_angle = g.hed - w.wdd;
    if (polar_angle < 0)
      polar_angle = 360 + polar_angle

    //stateの更新
    this.setState({
      deviceMap: newDevMap,
      center: this.getMapCenter(p.target.gpsLine),
      selectedSpd: g.spd,
      selectedDir: polar_angle,
      memberPolar: mp,
    });

  }

  getMapCenter(gpses) {
    var lat = 0;
    var lon = 0;
    gpses.forEach((gps) => {
      lat += gps[0];
      lon += gps[1];
    });
    lat = lat / gpses.length;
    lon = lon / gpses.length;
    return ({ lat: lat, lng: lon });
  }

  //Practice or Legデータロード後に呼び出される
  //componentWillReceiveProps(nextProps) {
  componentDidUpdate() {

    // Typical usage (don't forget to compare props):
    if (!this.props.targetUser) {
      this.props.loaded();
      return;
    }

    //前回のtargetUserが異なっていたら、このタイミングでDeviceリストを強制リセット
    if (prevUserId != this.props.targetUser.id) {
      //前回の履歴はクリア
      prevPracticeId = null;
      prevLegId = null;
      upd_time = null;
      prevUserId = null;
      prevPractices = null;

      //Deviceリストも初期化する(切り替え直後がtarget==undefinedという前提で、以後のState変更ロジックが動かない想定
      let newDevMap = {};
      this.setState({
        deviceMap: newDevMap,
      });
      prevUserId = this.props.targetUser.id;
      return;
    }


    if (this.props.target == undefined) {
      return;
    } else {
      //reset if practice changed
      if ((prevPracticeId != this.props.target.id) || (prevLegId != this.props.target.currentLeg)
        || (upd_time != this.props.upd_time)) {
        this.initListData();
        this.initDeviceMap();
        this.changeGraph(this.state.gridIndex);
        this.initMemberDeviceMap();
      }
      //updete now Practice ID
      prevPracticeId = this.props.target.id;
      prevLegId = this.props.target.currentLeg;
      upd_time = this.props.upd_time;
      prevUserId = this.props.target.user.id;

    }

  }

  handleSelectTargetPracticesOrLeg(target) {
    this.loadTarget({ target: target, user: this.props.targetUser });
  }

  //PracticeまたはLegのロード
  loadTarget({ target }) {
    this.props.loading();

    if (target != undefined) {
      target.themeColor1 = '#ff5100';
      target.themeColor2 = '#3a5a98';
      this.setState({
        isLoaded: false,
      });
      target.load({ onSuccess: this.finalizeLoadTarget, props: this.props });
    } else {
      //targetの更新
      this.props.updateTarget({ target: undefined });
      this.setState({
        isLoaded: true,
      });
    }
  }

  //コールバック関数
  finalizeLoadTarget(target, props) {

    props.getCalcPattern({ target: target });//Leg分割パターンの取得

    if (props.compare) {
      props.updateCompare({ target: target });
      return;
    }
    else {
      props.updatePolar({ target: target });
    }


    if (!props.members) {
      //update Graph data
      props.updateDispData({ target: target, user: props.targetUser });
    } else {
      //or If already selected member
      var flg = false;
      props.members.forEach((member) => {
        if ((member.isActive) && (target)) {
          props.getMembersPractices({ target: target, from: target.started_at, to: target.ended_at, member: member, user: props.targetUser });
          flg = true;
        }
      });

      //Activeが１つもないまたは、targetがないとき、普通にロードする。
      if (!flg)
        props.updateDispData({ target: target, user: props.targetUser });
    }
    props.loaded();
  }

  reLoadMap() {
  }


  // 時刻から target.gpses (生データ) のインデックスを二分探索で高速取得
  getGpsesIndexFromTime(timeStrOrMoment) {
    const gpses = this.props.target && this.props.target.gpses;
    if (!gpses || gpses.length === 0) return 0;

    let targetMoment = moment.isMoment(timeStrOrMoment)
      ? timeStrOrMoment.clone()
      : moment(timeStrOrMoment, ['HH:mm:ss.SS', 'HH:mm:ss', moment.ISO_8601]);

    if (!targetMoment.isValid()) return 0;

    const firstGps = gpses[0];
    const firstTime = moment.isMoment(firstGps.time) ? firstGps.time : moment(firstGps.time);
    if (!moment.isMoment(timeStrOrMoment)) {
      targetMoment.year(firstTime.year()).month(firstTime.month()).date(firstTime.date());
      if (targetMoment.isBefore(firstTime.clone().subtract(12, 'hours'))) {
        targetMoment.add(1, 'days');
      }
    }

    const targetVal = targetMoment.valueOf();

    let low = 0;
    let high = gpses.length - 1;
    let bestIdx = 0;
    let minDiff = Infinity;

    while (low <= high) {
      let mid = Math.floor((low + high) / 2);
      let gTime = gpses[mid].time;
      let gMoment = moment.isMoment(gTime) ? gTime : moment(gTime);
      let gVal = gMoment.valueOf();
      let diff = Math.abs(gVal - targetVal);

      if (diff < minDiff) {
        minDiff = diff;
        bestIdx = mid;
      }

      if (gVal < targetVal) {
        low = mid + 1;
      } else if (gVal > targetVal) {
        high = mid - 1;
      } else {
        return mid;
      }
    }
    return bestIdx;
  }

  handleSelectDataRange(event) {
    let selectedPoint = { firstPoint: event[0], secondPoint: event[1] };
    let selectedStartTime = this.props.gpsLog[selectedPoint.firstPoint].time;
    let selectedEndTime = this.props.gpsLog[selectedPoint.secondPoint].time;
    this.setState(state => ({
      select_from_t: selectedStartTime,
      select_to_t: selectedEndTime,
    }));

    // target.gpses (生データ) 側のインデックスを算出
    let target_from_idx = this.getGpsesIndexFromTime(selectedStartTime);
    let target_to_idx = this.getGpsesIndexFromTime(selectedEndTime);

    //統計値の再計算
    this.props.reCalculationSummary({ target: this.props.target, from_idx: target_from_idx, to_idx: target_to_idx });

    //Map上のラインの表示
    let gpsLine = [];
    if (this.props.target && this.props.target.gpses) {
      for (let i = target_from_idx; i <= target_to_idx; i++) {
        let gps = this.props.target.gpses[i];
        if (gps && gps.lat && gps.lon) {
          gpsLine.push([gps.lat, gps.lon]);
        }
      }
    }
    this.setState({
      calcLine: gpsLine
    });
  }

  setSlider(points) {
    if (points[1] - points[0] + 1 < 5) {
      alert("Data length must be at least 5 seconds.");
      return;
    }
    this.setState(state => ({
      selectionRange: {
        min: points[0],
        max: points[1]
      },
    }));
  }

  handleColorModeChange = (val) => {
    if (val) this.setState({ colorMode: val });
  };

  //秒数指定ボタン
  handleClickSelectTime(t) {
    let r = this.state.selectionRange;
    let gpsLog = this.props.gpsLog;
    if (!gpsLog || gpsLog.length === 0) return;

    let max = gpsLog.length - 1;
    let startTimeStr = gpsLog[r.min].time;
    let startTime = moment(startTimeStr, ['HH:mm:ss.SS', 'HH:mm:ss']);
    let targetEndTime = startTime.clone().add(t, 'seconds');
    let targetEndMs = targetEndTime.hours() * 3600000 + targetEndTime.minutes() * 60000 + targetEndTime.seconds() * 1000 + targetEndTime.milliseconds();

    let new_max = max;
    for (let i = r.min; i <= max; i++) {
      let tMoment = moment(gpsLog[i].time, ['HH:mm:ss.SS', 'HH:mm:ss']);
      let tMs = tMoment.hours() * 3600000 + tMoment.minutes() * 60000 + tMoment.seconds() * 1000 + tMoment.milliseconds();
      if (tMs >= targetEndMs) {
        new_max = i;
        break;
      }
    }

    let selectedStartTime = startTimeStr;
    let selectedEndTime = gpsLog[new_max].time;

    this.setState(state => ({
      select_from_t: selectedStartTime,
      select_to_t: selectedEndTime,
      selectionRange: {
        min: r.min,
        max: new_max,
      }
    }));

    // target.gpses (生データ) 側のインデックスを算出
    let target_from_idx = this.getGpsesIndexFromTime(selectedStartTime);
    let target_to_idx = this.getGpsesIndexFromTime(selectedEndTime);

    //統計値の再計算
    this.props.reCalculationSummary({ target: this.props.target, from_idx: target_from_idx, to_idx: target_to_idx });

    //Map上のラインの表示
    let gpsLine = [];
    if (this.props.target && this.props.target.gpses) {
      for (let i = target_from_idx; i <= target_to_idx; i++) {
        let gps = this.props.target.gpses[i];
        if (gps && gps.lat && gps.lon) {
          gpsLine.push([gps.lat, gps.lon]);
        }
      }
    }
    this.setState({
      calcLine: gpsLine
    });
  }

  //アップインドデータコピーボタン
  handleClickCopyUpData() {
    let out = "Sail_no";
    out = this.props.target.wind_direction + "\n";
    out += this.props.target.st.format("kk:mm:ss") + "\n";
    out += this.props.target.et.format("kk:mm:ss") + "\n\n";
    out += this.props.target.max_speed + "\n";
    out += this.props.target.max_10s_spd + "\n";
    out += this.props.target.ave_speed + "\n";
    out += this.props.target.ave_vmg_up;

    //クリップボードにコピー
    copyToClipboard(out);
  }

  //ダウンウインドデータコピーボタン
  handleClickCopyDwData() {
    let out = "Sail_no";
    out = this.props.target.wind_direction + "\n";
    out += this.props.target.st.format("kk:mm:ss") + "\n";
    out += this.props.target.et.format("kk:mm:ss") + "\n\n";
    out += this.props.target.max_speed + "\n";
    out += this.props.target.max_10s_spd + "\n";
    out += this.props.target.ave_speed + "\n";
    out += this.props.target.ave_vmg_down;

    //クリップボードにコピー
    copyToClipboard(out);

  }

  //Pitch/Rollデータコピーボタン
  handleClickCopyMotionData() {
    let out = "";
    let target_from_idx = this.getGpsesIndexFromTime(this.state.select_from_t);
    let target_to_idx = this.getGpsesIndexFromTime(this.state.select_to_t);
    if (this.props.target && this.props.target.gpses) {
      for (let i = target_from_idx; i <= target_to_idx; i++) {
        let gps = this.props.target.gpses[i];
        if (!gps) continue;
        let tStr = moment.isMoment(gps.time) ? gps.time.format("kk:mm:ss") : gps.time;
        out += tStr + "\t";
        out += (gps.speed !== undefined ? gps.speed : gps._speed) + "\t";
        out += (gps.pitch !== undefined ? gps.pitch : gps._pitch) + "\t";
        out += (gps.roll !== undefined ? gps.roll : gps._roll) + "\n";
      }
    }

    //クリップボードにコピー
    copyToClipboard(out);
  }


  // AirTack分析 ----------------------
  _getIndexFromTime(targetTimeStr) {
    return this.getGpsesIndexFromTime(targetTimeStr);
  }

  handleClickAirTackData() {
    let from = this._getIndexFromTime(this.state.select_from_t);
    let to = this._getIndexFromTime(this.state.select_to_t);
    let out = "";

    let deviceId;
    let deviceType;
    let fullname;
    let sailno;
    if (this.props.target instanceof Practice) {
      deviceId = this.props.target.device_id;
      deviceType = this.props.target.device_type;
      fullname = this.props.target.user.first_name;
      sailno = this.props.target.user.last_name;
    } else if (this.props.target instanceof Leg) {
      deviceId = this.props.target.practice.device_id;
      deviceType = this.props.target.practice.device_type;
      fullname = this.props.target.practice.user.first_name;
      sailno = this.props.target.practice.user.last_name;
    } else {
      console.warn("Unknown target class");
      deviceId = null;
    }

    //Header
    out += "時刻,";
    out += "デバイスID,";
    out += "選手名,";
    out += "センサタイプ,";
    out += "選手No,";
    out += "移動方位,";
    out += "Angle(風に対する走行角度）,";
    out += "緯度,";
    out += "経度,";
    out += "風向,";
    out += "風速,";
    out += "移動速度,";
    out += "VMG,";
    out += "距離,";
    out += "pitch,";
    out += "roll,";
    out += "yaw,";
    out += "ax,";
    out += "ay,";
    out += "az,";
    out += "gx,";
    out += "gy,";
    out += "gz,";
    out += "mx,";
    out += "my,";
    out += "mz,";
    out += "heave,";
    out += "着眼点(開始時刻),";
    out += "着眼点(終了時刻),";
    out += "着眼点(所要時間),";
    out += "着眼点(平均速度AVG),";
    out += "着眼点(最大速度MaxSPD),";
    out += "着眼点(最低速度MinSPD),";
    out += "着眼点(Max2S SPD),";
    out += "着眼点(Max10S SPD),";
    out += "着眼点(平均UP VMG),";
    out += "着眼点(最大UP VMG),";
    out += "着眼点(平均DW VMG),";
    out += "着眼点(最大DW VMG),";
    out += "着眼点(平均角度roll),";
    out += "着眼点(平均角度pitch),";
    out += "着眼点(安定度roll),";
    out += "着眼点(安定度Pitch),";
    out += "\n";


    //着眼点：統計データの作成
    let start_time = this.props.target.gpses[from].time;
    let end_time = this.props.target.gpses[to].time;
    let duration = (end_time - start_time) / 1000;
    let max_speed = 0;
    let min_speed = 9999;
    let ave_speed = 0;
    let ave_roll = 0;
    let ave_pitch = 0;
    let max2s = 0;
    let max10s = 0;
    let aveUpVmg = 0;
    let maxUpVmg = 0;
    let aveDwVmg = 0;
    let maxDwVmg = 0;
    let aveRollStable = 0;
    let avePitchStable = 0;

    let gps_count = 0;
    let motion_count = 0;
    let up_count = 0;
    let dw_count = 0;

    for (let i = from; i <= to; i++) {
      let gps = this.props.target.gpses[i];
      let motions = gps.motions;
      let time = gps.time;
      let delta = 0
      let prev_pitch = 0;
      let prev_roll = 0;
      if (motions) {
        for (const motion of motions) {
          ave_pitch = ave_pitch + motion.pitch
          ave_roll = ave_roll + motion.roll

          //stable
          avePitchStable += prev_pitch - motion.pitch;
          prev_pitch = motion.pitch;
          aveRollStable += prev_roll - motion.roll;
          prev_roll = motion.roll;

          motion_count++;
        }
      }

      //max 
      if (max_speed < gps.speed) {
        max_speed = gps.speed
      }
      if (min_speed > gps.speed) {
        min_speed = gps.speed
      }
      if (maxUpVmg < gps.vmg) {
        maxUpVmg = gps.vmg
      }
      if (maxDwVmg > gps.vmg) {
        maxDwVmg = gps.vmg
      }

      //max xxS
      let gpses = this.props.target.gpses;
      let tmp = 0;
      let sec = 2;
      for (let j = i; j <= i + (sec - 1); j++) {
        if (j <= to) {
          tmp += gpses[j].speed
        }
      }
      tmp = tmp / sec;
      if (max2s < tmp) {
        max2s = tmp;
      }
      tmp = 0;
      sec = 10;
      for (let j = i; j <= i + (sec - 1); j++) {
        if (j <= to) {
          tmp += gpses[j].speed
        }
      }
      tmp = tmp / sec;
      if (max10s < tmp) {
        max10s = tmp;
      }

      //average
      ave_speed = ave_speed + gps.speed
      if (gps.vmg > 0) {
        aveUpVmg = aveUpVmg + gps.vmg
        up_count++;
      } else {
        aveDwVmg = aveDwVmg + gps.vmg
        dw_count++;
      }
      gps_count++;
    }

    //average
    ave_pitch = ave_pitch / motion_count;
    ave_roll = ave_roll / motion_count;
    avePitchStable = avePitchStable / motion_count;
    aveRollStable = aveRollStable / motion_count;
    ave_speed = ave_speed / gps_count;
    aveUpVmg = aveUpVmg / up_count;
    aveDwVmg = aveDwVmg / dw_count;

    const km = 1.852;


    //データの出力
    let gpsData = []
    for (let i = from; i <= to; i++) {
      let gps = this.props.target.gpses[i];

      let motions = gps.motions;
      let time = gps.time;
      let delta = 0

      //Polarに渡す風上に対する角度を計算
      let angle = gps.direction - gps.wind_direction;
      if (angle < 0) {
        angle = 360 + angle
      }


      if (motions) {
        for (const motion of motions) {
          time.add(delta, 'milliseconds');
          out += time.format('YYYY-MM-DD HH:mm:ss.SSS') + ",";
          out += deviceId + ",";
          out += fullname + ",";
          out += deviceType + ",";
          out += sailno + ",";
          out += gps.direction + ",";
          out += angle + ",";
          out += gps.lat + ",";
          out += gps.lon + ",";
          out += gps.wind_direction + ",";
          out += gps.wind_speed + ",";
          out += gps.speed * km + ",";
          out += gps.vmg * km + ",";
          out += gps.distance + ",";
          out += motion.pitch + ",";
          out += motion.roll + ",";
          out += motion.yaw + ",";
          out += motion.ax + ",";
          out += motion.ay + ",";
          out += motion.az + ",";
          out += motion.gx + ",";
          out += motion.gy + ",";
          out += motion.gz + ",";
          out += motion.mx + ",";
          out += motion.my + ",";
          out += motion.mz + ",";
          out += motion.heave + ",";
          out += start_time.format('YYYY-MM-DD HH:mm:ss.SSS') + ",";
          out += end_time.format('YYYY-MM-DD HH:mm:ss.SSS') + ",";
          out += duration + ",";
          out += ave_speed * km + ",";
          out += max_speed * km + ",";
          out += min_speed * km + ",";
          out += max2s * km + ",";
          out += max10s * km + ",";
          out += aveUpVmg * km + ",";
          out += maxUpVmg * km + ",";
          out += aveDwVmg * km + ",";
          out += maxDwVmg * km + ",";
          out += ave_roll + ",";
          out += ave_pitch + ",";
          out += aveRollStable + ",";
          out += avePitchStable + ",";
          out += "\n";
          delta = motion.dt;
        }
      } else {
        out += time.format('YYYY-MM-DD HH:mm:ss.SSS') + ",";
        out += deviceId + ",";
        out += fullname + ",";
        out += deviceType + ",";
        out += sailno + ",";
        out += gps.direction + ",";
        out += angle + ",";
        out += gps.lat + ",";
        out += gps.lon + ",";
        out += gps.wind_direction + ",";
        out += gps.wind_speed + ",";
        out += gps.speed * km + ",";
        out += gps.vmg * km + ",";
        out += gps.distance + ",";
        out += "null" + ",";
        out += "null" + ",";
        out += "null" + ",";
        out += "null" + ",";
        out += "null" + ",";
        out += "null" + ",";
        out += "null" + ",";
        out += "null" + ",";
        out += "null" + ",";
        out += "null" + ",";
        out += "null" + ",";
        out += "null" + ",";
        out += "null" + ",";
        out += start_time.format('YYYY-MM-DD HH:mm:ss.SSS') + ",";
        out += end_time.format('YYYY-MM-DD HH:mm:ss.SSS') + ",";
        out += duration + ",";
        out += ave_speed * km + ",";
        out += max_speed * km + ",";
        out += min_speed * km + ",";
        out += max2s * km + ",";
        out += max10s * km + ",";
        out += aveUpVmg * km + ",";
        out += maxUpVmg * km + ",";
        out += aveDwVmg * km + ",";
        out += maxDwVmg * km + ",";
        out += ave_roll + ",";
        out += ave_pitch + ",";
        out += aveRollStable + ",";
        out += avePitchStable + ",";
        out += "\n";
      }


    }

    //クリップボードにコピー
    copyToClipboard(out);

    //csvファイルで保存
    downloadCSV(out,
      start_time.format('YYYY-MM-DD HH:mm:ss.SSS') + "_" +
      end_time.format('YYYY-MM-DD HH:mm:ss.SSS') + "_" +
      deviceType + "_" +
      deviceId + "_" +
      sailno + ".csv");
  };

  render() {
    if (this.props.target == undefined) {
      return <Loading />;
    }

    var GraphArea;
    const rowStyle = { padding: '1px' };
    var graphStyle = { width: '100%', minWidth: '100px', height: this.state.graphHeight, padding: '1px' };

    // 区間選択中かどうかの判定
    const isRangeSelected = this.state.calcLine.length > 0;
    const selRange = this.state.selectionRange;
    const dRange = this.state.dataRange;

    // グラフデータにグレーアウト用のキーを追加
    let graphData = this.state.graph;
    const grayKeyStb = '_gray_stb';
    const grayKeyPt = '_gray_pt';

    if (isRangeSelected && graphData && graphData.length > 0) {
      graphData = graphData.map((item, idx) => {
        const isInSelection = idx >= selRange.min && idx <= selRange.max;
        const newItem = { ...item };
        if (isInSelection) {
          // 選択区間内: グレー用キーはnull
          newItem[grayKeyStb] = null;
          newItem[grayKeyPt] = null;
        } else {
          // 選択区間外: グレー用キーに値をコピー、カラー用キーをnullに
          newItem[grayKeyStb] = item[this.state.dataKeyStb];
          newItem[grayKeyPt] = item[this.state.dataKeyPt];
          newItem[this.state.dataKeyStb] = null;
          newItem[this.state.dataKeyPt] = null;
        }
        return newItem;
      });
    }

    GraphArea = (
      <div style={graphStyle}>
        <ResponsiveContainer width="100%" height="100%" minHeight={100}>
          <LineChart data={graphData} onMouseMove={this.handleMouseMoveOnGraph} >
            <YAxis reversed={this.state.yaxis} />
            <Tooltip />
            {this.state.colorMode === 'speed' && (
              <defs>
                <linearGradient id="speedGradient" x1="0" y1="1" x2="0" y2="0">
                  {this.renderGradientStops()}
                </linearGradient>
              </defs>
            )}
            <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
            {/* 非選択区間のグレーライン（区間選択時のみ描画） */}
            {isRangeSelected && (
              <Line
                type="monotone"
                dataKey={grayKeyStb}
                stroke="#999"
                strokeWidth={1}
                isAnimationActive={false}
                connectNulls={false}
                dot={false}
                strokeOpacity={0.4}
              />
            )}
            {isRangeSelected && (
              <Line
                type="monotone"
                dataKey={grayKeyPt}
                stroke="#999"
                strokeWidth={1}
                isAnimationActive={false}
                connectNulls={false}
                dot={false}
                strokeOpacity={0.4}
              />
            )}
            <Line
              type="monotone"
              dataKey={this.state.dataKeyStb}
              stroke={this.state.colorMode === 'speed' ? "url(#speedGradient)" : "#006400"}
              strokeWidth={this.state.colorMode === 'speed' ? 3 : 1}
              isAnimationActive={false}
              connectNulls={false}
              dot={false}
            />
            <Line
              type="monotone"
              dataKey={this.state.dataKeyPt}
              stroke={this.state.colorMode === 'speed' ? "url(#speedGradient)" : "#dc143c"}
              strokeWidth={this.state.colorMode === 'speed' ? 3 : 1}
              isAnimationActive={false}
              connectNulls={false}
              dot={false}
            />
            <Line
              type="monotone"
              dataKey={this.state.dataKeyMember}
              stroke="#a9a9a9"
              isAnimationActive={false}
              dot={false}
            />
            {this.state.deviceMap[this.props.target.user.id] && this.state.deviceMap[this.props.target.user.id].maxSpeedPoint && (
              <ReferenceDot
                x={this.state.deviceMap[this.props.target.user.id].maxSpeedPoint.index}
                y={this.state.deviceMap[this.props.target.user.id].maxSpeedPoint.speed}
                r={4}
                fill="gold"
                stroke="none"
              />
            )}
          </LineChart>
        </ResponsiveContainer>
      </div>
    );

    this.props.GraphArea(GraphArea);


    let polar_tab = (
      <Tab eventKey="polar" title="Polar">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-lg-7">
              <Polar polarSize={this.state.polarSize} polar={this.props.target.polar} memberPolar={this.state.memberPolar} selectedDir={this.state.selectedDir} selectedSpd={this.state.selectedSpd} maxVmg={this.props.target.max_vmg} test={this.state.test} />
            </div> {/*col*/}
            <div className="d-none d-lg-block col-lg-5" >
              <Summary target={this.props.target} list={this.state.list} authUser={this.props.authUser} />
            </div> {/*col*/}
          </div> {/*row*/}
        </div> {/*container*/}
      </Tab>
    )

    let sailing_tab = (
      <Summary2 target={this.props.target} list={this.state.list} authUser={this.props.authUser} />
    )

    let rowing_tab = (
      <SummaryRowing target={this.props.target} authUser={this.props.authUser} />
    )

    let autorace_tab = (
      <SummaryAutoRace target={this.props.target} authUser={this.props.authUser} />
    )

    let sailing_table = (
      <Table striped bordered hover variant="dark">
        <tbody >
          <tr>
            <td className={this.state.dataKeyId === 0 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 0)}>
              <span className="Unit2" >SOG</span>
              <span className="summary">{this.state.list[0].value}</span>
              <span className="Unit2">{this.props.authUser.unit}</span>
            </td>
            <td className={this.state.dataKeyId === 1 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 1)}><span className="Unit2" >VMG</span>  <span className="summary">{this.state.list[1].value} </span> <span className="Unit2">{this.props.authUser.unit}</span></td>
          </tr>
          <tr>
            <td className={this.state.dataKeyId === 2 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 2)}><span className="Unit2" >TWA</span> <span className="summary">{this.state.list[2].value} </span><span className="Unit2">{this.state.list[2].unit}</span></td>
            <td className={this.state.dataKeyId === 3 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 3)}><span className="Unit2" >Heading</span> <span className="summary">{this.state.list[3].value} </span><span className="Unit2">{this.state.list[3].unit}</span></td>
          </tr>
          <tr>
            <td className={this.state.dataKeyId === 4 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 4)}><span className="Unit2" >TWS</span> <span className="summary">{this.state.list[4].value} </span><span className="Unit2">{this.state.list[4].unit}</span></td>
            <td className={this.state.dataKeyId === 5 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 5)}><span className="Unit2" >TWD</span> <span className="summary">{this.state.list[5].value} </span><span className="Unit2">{this.state.list[5].unit}</span></td>
          </tr>
          {true &&
            <tr>
              <td className={this.state.dataKeyId === 6 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 6)}><span className="Unit2" >Pitch</span> <span className="summary">{this.state.list[6].value} </span><span className="Unit2">{this.state.list[6].unit}</span></td>
              <td className={this.state.dataKeyId === 7 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 7)}><span className="Unit2" >Heel</span>  <span className="summary">{this.state.list[7].value}</span> <span className="Unit2">{this.state.list[7].unit}</span></td>
            </tr>
          }
          <tr>
            <td className={this.state.dataKeyId === 8 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 8)}><span className="Unit2" >DTM</span> <span className="summary">{this.state.list[8].value} </span><span className="Unit2">{this.state.list[8].unit}</span></td>
            <td className={this.state.dataKeyId === 9 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 9)}><span className="Unit2" >VMC</span>  <span className="summary">{this.state.list[9].value}</span> <span className="Unit2">{this.props.authUser.unit}</span></td>
          </tr>
          <tr>
            <td className={this.state.dataKeyId === 10 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 10)}><span className="Unit2" >DistUp</span> <span className="summary">{this.state.list[10].value} </span><span className="Unit2">{this.state.list[10].unit}</span></td>
            <td className={this.state.dataKeyId === 11 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 11)}><span className="Unit2" >Log</span> <span className="summary">{this.state.list[11].value} </span><span className="Unit2">{this.state.list[11].unit}</span></td>
          </tr>
          {this.props.practices && this.props.practices.length > 0 && (
            <tr>
              <td className={this.state.dataKeyId === 13 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 13)}><span className="Unit2" >Dist2Member</span> <span className="summary">{this.state.list[13] ? this.state.list[13].value : 0} </span><span className="Unit2">m</span></td>
              <td />
            </tr>
          )}
        </tbody>
      </Table>
    )

    let rowing_table = (
      <Table striped bordered hover variant="dark">
        <tbody >
          <tr>
            <td className={this.state.dataKeyId === 0 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 0)}><span className="Unit2" >SOG</span> <span className="summary">{this.state.list[0].value} </span><span className="Unit2">{this.props.authUser.unit}</span></td>
            <td className={this.state.dataKeyId === 3 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 3)}><span className="Unit2" >Heading</span> <span className="summary">{this.state.list[3].value} </span><span className="Unit2">{this.state.list[3].unit}</span></td>
          </tr>
          <tr>
            <td className={this.state.dataKeyId === 2 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 2)}><span className="Unit2" >TWA</span> <span className="summary">{this.state.list[2].value} </span><span className="Unit2">{this.state.list[2].unit}</span></td>
            <td className={this.state.dataKeyId === 11 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 11)}><span className="Unit2" >Log</span> <span className="summary">{this.state.list[11].value} </span><span className="Unit2">{this.state.list[11].unit}</span></td>
          </tr>
          {this.props.practices && this.props.practices.length > 0 && (
            <tr>
              <td className={this.state.dataKeyId === 13 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 13)}><span className="Unit2" >Dist2Member</span> <span className="summary">{this.state.list[13] ? this.state.list[13].value : 0} </span><span className="Unit2">m</span></td>
              <td />
            </tr>
          )}
        </tbody>
      </Table>
    )

    let autorace_table = (
      <Table striped bordered hover variant="dark">
        <tbody >
          <tr>
            <td className={this.state.dataKeyId === 0 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 0)}>
              <span className="Unit2" >SPEED</span>
              <span className="summary">{this.state.list[0].value}</span>
              <span className="Unit2">{this.props.authUser.unit}</span>
            </td>
            <td className={this.state.dataKeyId === 3 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 3)}>
              <span className="Unit2" >Heading</span>
              <span className="summary">{this.state.list[3].value} </span>
              <span className="Unit2">{this.state.list[3].unit}</span>
            </td>
          </tr>
          <tr>
            <td className={this.state.dataKeyId === 6 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 6)}>
              <span className="Unit2" >Pitch</span>
              <span className="summary">{this.state.list[6].value} </span>
              <span className="Unit2">{this.state.list[6].unit}</span>
            </td>
            <td className={this.state.dataKeyId === 7 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 7)}>
              <span className="Unit2" >Roll</span>
              <span className="summary">{this.state.list[7].value}</span>
              <span className="Unit2">{this.state.list[7].unit}</span>
            </td>
          </tr>
          <tr>
            <td className={this.state.dataKeyId === 11 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 11)}>
              <span className="Unit2" >Log</span>
              <span className="summary">{this.state.list[11].value} </span>
              <span className="Unit2">{this.state.list[11].unit}</span>
            </td>
            <td className={this.state.dataKeyId === 12 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 12)}>
              <span className="Unit2" >Drift</span>
              <span className="summary">{this.state.list[12] ? this.state.list[12].value : 0} </span>
              <span className="Unit2">{this.state.list[12] ? this.state.list[12].unit : 'deg'}</span>
            </td>
          </tr>
          <tr>
            <td className={this.state.dataKeyId === 14 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 14)}>
              <span className="Unit2" >ax</span>
              <span className="summary">{this.state.list[14] ? this.state.list[14].value : 0} </span>
              <span className="Unit2">G</span>
            </td>
            <td className={this.state.dataKeyId === 15 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 15)}>
              <span className="Unit2" >ay</span>
              <span className="summary">{this.state.list[15] ? this.state.list[15].value : 0} </span>
              <span className="Unit2">G</span>
            </td>
          </tr>
          <tr>
            <td className={this.state.dataKeyId === 16 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 16)}>
              <span className="Unit2" >gz</span>
              <span className="summary">{this.state.list[16] ? this.state.list[16].value : 0} </span>
              <span className="Unit2">deg/s</span>
            </td>
            <td />
          </tr>
          {this.props.practices && this.props.practices.length > 0 && (
            <tr>
              <td className={this.state.dataKeyId === 13 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 13)}>
                <span className="Unit2" >Dist2Member</span>
                <span className="summary">{this.state.list[13] ? this.state.list[13].value : 0} </span>
                <span className="Unit2">m</span>
              </td>
              <td />
            </tr>
          )}
          <tr>
            <td colSpan="2" style={{ textAlign: 'center', cursor: 'pointer', fontWeight: 'bold', color: '#17a2b8' }} onClick={this.toggleIMU}>
              {this.state.showAllIMU ? "全データを閉じる" : "全データ表示"}
            </td>
          </tr>
          {this.state.showAllIMU && (
            <>
              <tr>
                <td className={this.state.dataKeyId === 17 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 17)}>
                  <span className="Unit2" >Az</span>
                  <span className="summary">{this.state.list[17] ? this.state.list[17].value : 0} </span>
                  <span className="Unit2">G</span>
                </td>
                <td className={this.state.dataKeyId === 18 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 18)}>
                  <span className="Unit2" >gx</span>
                  <span className="summary">{this.state.list[18] ? this.state.list[18].value : 0} </span>
                  <span className="Unit2">deg/s</span>
                </td>
              </tr>
              <tr>
                <td className={this.state.dataKeyId === 19 ? 'Active2' : 'NotActive2'} onClick={this.changeGraph.bind(this, 19)}>
                  <span className="Unit2" >gy</span>
                  <span className="summary">{this.state.list[19] ? this.state.list[19].value : 0} </span>
                  <span className="Unit2">deg/s</span>
                </td>
                <td />
              </tr>
            </>
          )}
        </tbody>
      </Table>
    )



    return (
      <Container>
        <Row style={{ height: '40vh' }} >
          <Col xs={5} lg={5} >
            <MapBrowser
              zoom={this.state.zoom}
              deviceMap={this.state.deviceMap}
              center={this.state.center}
              windSpeed={this.state.windspeed} windDirection={this.state.winddir}
              windpos={this.state.windpos}
              buoy_coordinate={this.props.target.buoy_coordinate}
              authUser={this.props.authUser}
              calcLine={this.state.calcLine}
              colorMode={this.state.colorMode}
              selectionRange={this.state.calcLine.length > 0 ? this.state.selectionRange : null}
              start_line={this.props.target.start_line}
            />
          </Col>
          <Col xs={7} lg={7} >
            <Tabs
              transition={false}
              defaultActiveKey="summary"
            >
              <Tab eventKey="track" title="Track">
                {isSailingLike(this.props.authUser.organization.event) ? sailing_table : (isAutoRace(this.props.authUser.organization.event) ? autorace_table : rowing_table)}
              </Tab>
              {isSailingLike(this.props.authUser.organization.event) ? polar_tab : ""}
              <Tab eventKey="motion" title="Motion">
                <div className="container">
                  <div className="row">
                    <div className="col-xs-12 col-lg-4">
                      <Motion title={"Pitch"} polarSize={this.state.polarSize} angle={this.state.list[6].value} value={this.state.list[6].value - 90} />
                    </div> {/*col*/}
                    <div className="col-xs-12 col-lg-4">
                      <Motion title={"Heel"} polarSize={this.state.polarSize} angle={this.state.list[7].value} value={this.state.list[7].value} />
                    </div> {/*col*/}
                    <div className="col-xs-12 col-lg-4">
                      {(() => {
                        let motionScatterData = [];
                        let motionActivePoint = [];
                        if (this.props.gpsLog) {
                          this.props.gpsLog.forEach((item) => {
                            if (item.ax !== undefined && item.ay !== undefined) {
                              motionScatterData.push({
                                x: -item.ay,
                                y: -item.ax,
                                time: item.time
                              });
                            }
                          });
                        }
                        if (this.props.gpsLog && this.state.now_t) {
                          const activeItem = this.props.gpsLog.find((item) => item.time === this.state.now_t);
                          if (activeItem && activeItem.ax !== undefined && activeItem.ay !== undefined) {
                            motionActivePoint.push({
                              x: -activeItem.ay,
                              y: -activeItem.ax,
                              time: activeItem.time
                            });
                          }
                        }

                        let maxVal = 0.5;
                        motionScatterData.forEach((d) => {
                          const absX = Math.abs(d.x);
                          const absY = Math.abs(d.y);
                          if (absX > maxVal) maxVal = absX;
                          if (absY > maxVal) maxVal = absY;
                        });
                        maxVal = Math.ceil(maxVal * 10) / 10;

                        return (
                          <div style={{ background: '#1a1a1a', padding: '15px', borderRadius: '8px', border: '1px solid #333', height: '100%', minHeight: '300px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <h4 style={{ color: '#fff', fontSize: '14px', textAlign: 'center', marginBottom: '5px', fontWeight: 'bold' }}>Acceleration G (G-G Plot)</h4>
                            <div style={{ fontSize: '10px', color: '#aaa', textAlign: 'center', marginBottom: '5px' }}>
                              ← 右ターン / 左ターン →  |  ↑ ブレーキ / ↓ 加速
                            </div>
                            <div style={{ width: '100%', height: '200px' }}>
                              <ResponsiveContainer width="100%" height="100%">
                                <ScatterChart margin={{ top: 5, right: 5, bottom: 5, left: 5 }}>
                                  <CartesianGrid strokeDasharray="3 3" stroke="#333" />
                                  <XAxis 
                                    type="number" 
                                    dataKey="x" 
                                    name="ay" 
                                    unit="G" 
                                    domain={[-maxVal, maxVal]} 
                                    stroke="#ccc"
                                    tick={{ fill: '#aaa', fontSize: 9 }}
                                  />
                                  <YAxis 
                                    type="number" 
                                    dataKey="y" 
                                    name="-ax" 
                                    unit="G" 
                                    domain={[-maxVal, maxVal]} 
                                    stroke="#ccc"
                                    tick={{ fill: '#aaa', fontSize: 9 }}
                                  />
                                  <ReferenceLine x={0} stroke="#888" strokeWidth={1} />
                                  <ReferenceLine y={0} stroke="#888" strokeWidth={1} />
                                  <Tooltip cursor={{ strokeDasharray: '3 3' }} />
                                  <Scatter name="G-Force" data={motionScatterData} fill="#00bcd4" opacity={0.4} />
                                  {motionActivePoint.length > 0 && (
                                    <Scatter name="Current" data={motionActivePoint} fill="#ff1744" r={8} stroke="#fff" strokeWidth={2} />
                                  )}
                                </ScatterChart>
                              </ResponsiveContainer>
                            </div>
                          </div>
                        );
                      })()}
                    </div> {/*col*/}
                  </div> {/*row*/}
                </div> {/*container*/}
              </Tab>

              <Tab eventKey="summary" title="Summary">
                {isSailingLike(this.props.authUser.organization.event) ? sailing_tab : (isAutoRace(this.props.authUser.organization.event) ? autorace_tab : rowing_tab)}
              </Tab>


              <Tab eventKey="member" title="Member">
                <TeamList target={this.props.target} />
              </Tab>

            </Tabs>

          </Col>
        </Row>
        {/*練習日　送り・戻しボタン*/}
        <div className="row">
          <div className="col-12 col-lg-4">
            {(this.props.authUser && this.props.authUser.organization && isSailingLike(this.props.authUser.organization.event)) && (
              <ToggleButtonGroup type="radio" name="options" value={this.state.colorMode} onChange={this.handleColorModeChange}>
                <ToggleButton value={'sailing'} variant={this.state.colorMode === 'sailing' ? 'primary' : 'secondary'}>S/P</ToggleButton>
                <ToggleButton value={'speed'} variant={this.state.colorMode === 'speed' ? 'primary' : 'secondary'}>Speed</ToggleButton>
              </ToggleButtonGroup>
            )}
          </div>
          <div className="col-1">
            <button className="btn btn-secondary" disabled={this.props.prevButtonState} onClick={() => this.handleClickLeg(this.props.target, this.handleSelectTargetPracticesOrLeg, -1)}>Prev</button>
          </div> {/*col*/}
          <div className="col-1">
            <button className="btn btn-secondary" disabled={this.props.nextButtonState} onClick={() => this.handleClickLeg(this.props.target, this.handleSelectTargetPracticesOrLeg, 1)}>Next</button>
          </div> {/*col*/}
          {this.state.isPC && <div className="col-1"></div>}
          <div className="col-8">
          </div> {/*col*/}
          <div className="col-1">
            <button disabled={this.props.nextButtonState} onClick={() => this.handleClickLeg(this.props.target, this.handleSelectTargetPracticesOrLeg, 1)}>Next</button>
          </div> {/*col*/}
        </div> {/*row*/}

        <Row style={rowStyle}>
          <Col >
            {this.props.isLoading ? (<FontAwesomeIcon icon={['fas', 'spinner']} size="3x" spin />) : ('')}
            {GraphArea}
          </Col >
        </Row>
        <Row>
          <Col xs={1}><span> {this.state.now_t} </span></Col>
          {this.state.isPC && <Col xs={1}></Col>}
          <Col xs={8}></Col>
          <Col xs={1}><span> {this.state.end_t} </span></Col>
        </Row>

        <Row>
          <Col xs={1}>
            <input
              type="text"
              value={this.state.select_from_t}
              onChange={(e) => this.setState({ select_from_t: e.target.value })}
            />
          </Col>
          {this.state.isPC && <Col xs={1}></Col>}
          <Col xs={8}></Col>
          <Col xs={1}>
            <input
              type="text"
              value={this.state.select_to_t}
              onChange={(e) => this.setState({ select_to_t: e.target.value })}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={1}></Col>
          <Slider
            dataRange={this.state.dataRange}
            selectionRange={this.state.selectionRange}
            handleSelectDataRange={this.handleSelectDataRange}
            setSlider={this.setSlider}
          />
        </Row>
        <Row>
          <div className="col-1">
            <button onClick={() => this.handleClickSelectTime(20)}>20s</button>
          </div> {/*col*/}
          <div className="col-1">
            <button onClick={() => this.handleClickSelectTime(60)}>60s</button>
          </div> {/*col*/}
          <div className="col-1">
            <button onClick={() => this.handleClickSelectTime(40)}>40s</button>
          </div> {/*col*/}
          <div className="col-1">
            <button onClick={() => this.handleClickCopyUpData()}>UPCPY</button>
          </div> {/*col*/}
          <div className="col-1">
            <button onClick={() => this.handleClickCopyDwData()}>DWCPY</button>
          </div> {/*col*/}
          <div className="col-1">
            <button onClick={() => this.handleClickCopyMotionData()}>MotionCPY</button>
          </div> {/*col*/}
          <div className="col-1">
            <button onClick={() => this.handleClickAirTackData()}>AirTack</button>
          </div> {/*col*/}
        </Row>

      </Container>
    );
  }
}


const mapStateToProps = state => {
  return {
    target: state.PlayerSelector.target,
    targetUser: state.PlayerSelector.user,

    members: state.TeamList.members,
    practices: state.TeamList.practices,
    gpsLog: state.TeamList.gpsLog,
    motionLog: state.TeamList.motionLog,
    windLog: state.TeamList.windLog,
    buoyLog: state.TeamList.buoyLog,
    member: state.TeamList.member, //target
    upd_time: state.TeamList.upd_time,
    max_up_distance: state.TeamList.max_up_distance,

    isLoading: state.Main.loading,
    prevButtonState: state.Main.prevButtonState,
    nextButtonState: state.Main.nextButtonState,
    authUser: state.auth.user,
    is_track_mode: state.Main.track_mode,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    loading: () => dispatch(main.loading()),
    loaded: () => dispatch(main.loaded()),
    GraphArea: (graphArea) => dispatch(main.graphArea(graphArea)),
    getCalcPattern: ({ target }) => dispatch(main.getCalcPattern({ target })),
    updatePolar: ({ target }) => dispatch(main.updatePolar({ target })),
    updateCompare: ({ target }) => dispatch(main.updateCompare({ target })),
    updateDispData: ({ target, members_practices, user }) => dispatch(main.updateDispData({ target, members_practices, user })),
    getMembersPractices: ({ target, from, to, member, user }) => dispatch(teamList.getMembersPractices({ target, from, to, member, user })),
    reCalculationSummary: ({ target, from_idx, to_idx }) => dispatch(playerSelector.reCalculationSummary({ target, from_idx, to_idx })),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Track);
